import md5 from './md5';
import JSON from './json';
import Base64 from './base64';

var sign = {
  params: {},
  video_params: {},
  sign_res: "",
  video_sign: "",
  video_key: "vdbo.yunstudy",
  api_key: "bLsBMeMaN10pN8z64TQ0fC3fztDlRsPn",
  // api_key: "C7t6hJz8F1dqVWJ8R9BeHbaZEzAvWMZS",

  //接口签名生成
  create_sign: function () {
    let newObj = {}; //创建一个新的对象，用于存放排好序的键值对
    Object.keys(this.params).sort().forEach(key => newObj[key] = this.params[key]);
    let _params = this.implode(",", newObj);
    _params = _params + this.api_key;
    _params = Base64.Base64._utf8_encode(_params);
    this.sign_res = md5.hex_md5(_params);
    return this.sign_res;
  },

  //创建data数据
  create_data: function () {
    let _params = JSON.parse(JSON.stringify(this.params)); // 简单深克隆
    // 添加公共参数
    // _params.AAPICOM_NAME = 'waiyutong';
    // _params.AAPICOM_KEY = '2hcwiwgr05y2jy0r9bn15bzdtl';
    return Base64.Base64.encode(JSON.stringify(_params));
  },

  //实现PHP的implode功能
  implode: function (glue = ',', data) {
    return Object.values(data).map(val => {
      if (!val && val !== 0 && val !== false) return '';
      if (typeof val === 'object') return this.implode(glue, val);
      return val;
    }).filter(e => e !== '').join(glue);
  },

  /**
   * base64编码
   * @param {Object} str
   */
  base64_encode: function (str) {
    return Base64.Base64.encode(str);
  },

  /**
   * base64解码
   * @param {Object} str
   */
  base64_decode: function (str) {
    return Base64.Base64.decode(str);
  },

  //生成请求组合参数
  encode_post: function () {
    return JSON.stringify({
      data: this.create_data(),
      sign: this.create_sign(),
    });
  },

  //解密数据
  decode_post: function (data) {
    let _param = data.data;
    // let _sign = data.sign;
    return JSON.parse(this.base64_decode(_param));
  }
};

//暴露出口
export default {
  ...sign,
  sign: sign,
};

